import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useSelector, useDispatch } from "react-redux";
import { useGetUserDataQuery } from "../../services/login";
import { useFetchQuery } from "../../services/cart";
import { useGetShippingAddressesQuery } from "../../services/login";
import { useCreateCheckoutMutation } from "../../services/checkout";
import Host from "../../Components/Host";
import { useTranslation } from "react-i18next";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import CircularProgress from "@mui/material/CircularProgress";
import Loader from "../../Components/Loader";
import Button from "@mui/joy/Button";
import { Modal } from "react-bootstrap";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import IconButton from "@mui/joy/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FooterText from "../../Components/CheckoutComponent/FooterText";
import GuestShippingAddress from "../../Components/CheckoutComponent/GuestShippingAddress";
import ShippingAddress from "../../Components/CheckoutComponent/ShippingAddress";
import CartItems from "../../Components/CheckoutComponent/CartItems";
import CartIInformation from "../../Components/CheckoutComponent/CartIInformation";
import RazerPay from "../../Components/CheckoutComponent/RazerPay";
import ConfirmCheckout from "../../Components/CheckoutComponent/ConfirmCheckout";
import ZiinaApplePay from "../../Components/CheckoutComponent/ZiinaApplePay";
import MaxCommerce from "../../Components/CheckoutComponent/MaxCommerce";
import StripePay from "../../Components/CheckoutComponent/StripePay";

const allINRCurrency = ["INR"];
const localCurrency = ["AED"];
const elseCurrency = ["SAR", "BHD", "GBP", "KWD", "OMR", "QAR", "INR"];
const allCurrencies = ["SAR", "BHD", "GBP", "KWD", "OMR", "QAR", "AED", "INR"];

function CheckoutPage() {
  const {
    userId,
    userToken,
    userEmail,
    userName,
    countryCode,
    cartToken,
    languageCode,
    guestShippment,
    guestPayment,
    isPurchase,
  } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const isAction = new URLSearchParams(location.search).get("action") || "default";
  const tapId = new URLSearchParams(location.search).get("tap_id") || null;
  const orderId = new URLSearchParams(location.search).get("order_id") || null;
  const orderToken = new URLSearchParams(location.search).get("order_token") || null;
  const couponCode = new URLSearchParams(location.search).get("coupon") || null;
  const userParams = { userId: userId, userToken: userToken, countryCode: countryCode };
  const [getSelectShipmentAddressId, setSelectShipmentAddressId] = React.useState();
  const ShippingInfo = useGetShippingAddressesQuery(userParams, { refetchOnMountOrArgChange: true, skip: !userId });
  const ShippingData = ShippingInfo?.data?.shipping_addresses;
  const selectedShipping = ShippingData?.find((s) => s.id === getSelectShipmentAddressId);
  const { data: userData } = useGetUserDataQuery(userParams, { refetchOnMountOrArgChange: true });
  const currency = userData?.contant?.currency;
  const {
    data: cartInfo,
    isLoading,
    isFetching,
    refetch,
  } = useFetchQuery({ coupon: couponCode, cartToken: cartToken, ...userParams }, { refetchOnMountOrArgChange: true });
  const cartData = cartInfo?.cart;
  const thisToken = cartInfo?.token;
  const couponData = cartInfo?.coupon;

  const [isAddressModal, setAddressModal] = useState(false);

  const [getTestLoading, setTestLoading] = useState(false);
  const [checkoutData, setCheckoutData] = React.useState({});
  const [getCardCheckoutData, cardCheckoutData] = React.useState({});

  const [isRazerPaySelected, setRazerPaySelected] = React.useState(false);
  const [isRazerPaySelected2, setRazerPaySelected2] = React.useState(false);

  const [isZiinaApplePaySelected, setZiinaApplePaySelected] = React.useState(false);
  const [isZiinaApplePaySelected2, setZiinaApplePaySelected2] = React.useState(false);

  const [isMaxCommerceSelected, setMaxCommerceSelected] = React.useState(false);
  const [isMaxCommerceSelected2, setMaxCommerceSelected2] = React.useState(false);

  const [getPayByIframe, setPayByIframe] = React.useState(false);
  const [getIframeMessage, setIframeMessage] = React.useState("");

  const [isStripePaySelected, setStripePaySelected] = React.useState(false);

  function closePayByIframe() {
    setPayByIframe(false);
  }

  // call checkout action
  const [createcheckout, checkoutResult] = useCreateCheckoutMutation();
  const [isShippingAddress, setShippingAddress] = useState({});

  useEffect(() => {
    if (checkoutResult?.isSuccess) {
      setTestLoading(true);

      const responseData = checkoutResult?.data?.data;
      const tokenUrl = responseData?.redirect_url || responseData?.checkout_url || responseData?.payment_url;

      window.location.href = tokenUrl;

      setTestLoading(false);
    }
    if (checkoutResult?.isError) {
      setPayByIframe(false);
      setTestLoading(false);
    }
  }, [checkoutResult, checkoutResult?.isSuccess, getTestLoading]);

  useEffect(() => {
    if (guestShippment?.name) {
      refetch();
    }
    if (selectedShipping?.name) {
      refetch();
    }
  }, [guestShippment, ShippingInfo]);

  const TotalPrice = cartData?.reduce((accumulator, value) => {
    const productPrice = value.prices?.value * value.quantity;
    return accumulator + productPrice;
  }, 0);

  // checkout payload
  const userInformation =
    userId && userToken
      ? {
          userId: userId,
          userToken: userToken,
          userEmail: userEmail,
          customer_name: selectedShipping?.name,
          customer_email: userEmail,
          payment_mode: "user",
          customer_phone: selectedShipping?.phone,
        }
      : {
          customer_name: guestShippment?.name,
          customer_email: guestShippment?.email,
          userEmail: guestShippment?.email,
          payment_mode: "guest",
          customer_phone: guestShippment?.phone,
        };

  useEffect(() => {
    if (selectedShipping?.name) {
      setShippingAddress({
        address: selectedShipping?.address,
        city: selectedShipping?.city,
        city_code: selectedShipping?.city_code,
        country: selectedShipping?.country,
        country_code: selectedShipping?.country_code,
        email: selectedShipping?.email,
        name: selectedShipping?.name,
        phone: selectedShipping?.phone,
        street: selectedShipping?.street,
        zip_code: selectedShipping?.zip_code,
      });
    } else {
      setShippingAddress({
        address: guestShippment?.address,
        city: guestShippment?.city,
        city_code: guestShippment?.city_code,
        country: guestShippment?.country,
        country_code: guestShippment?.country_code,
        email: guestShippment?.email,
        name: guestShippment?.name,
        phone: guestShippment?.phone,
        street: guestShippment?.street,
        zip_code: guestShippment?.zip_code,
      });
    }
  }, [selectedShipping?.name, guestShippment?.name, isShippingAddress?.name]);

  const phoneNumber = userInformation?.customer_phone || "";
  const parsedNumber = parsePhoneNumberFromString(phoneNumber);
  const countryPhoneCode = parsedNumber?.countryCallingCode;
  const countryPhoneNumber = parsedNumber?.nationalNumber;

  const checkoutPayload = {
    shipping_address: isShippingAddress,
    shipping_address_id: getSelectShipmentAddressId,
    language: languageCode,
    country: countryCode,
    countryCode: countryCode,
    currency: cartData?.[0]?.prices?.currency,
    amount: couponData ? Number(TotalPrice) - Number(couponData?.discount) : Number(TotalPrice),
    shipping_price: Number(userData?.contant?.standard_delivery),
    delivery_days: Number(userData?.contant?.delivery_days),
    products: cartData,
    cartToken: cartToken,
    domainName: Host?.domainName,
    domain: window.location.hostname,
    domainEmail: Host?.email,
    token: thisToken,
    coupon: couponData ? couponData : null,
    payment_by: checkoutData?.payment_by,
    tabby_id: checkoutData?.tabby_id,
    card_id: checkoutData?.card_id,
    customer_id: checkoutData?.customer_id,
    countryPhoneCode: countryPhoneCode,
    countryPhoneNumber: countryPhoneNumber,
    customer: userData?.user?.customer,
    data: getCardCheckoutData?.id ? getCardCheckoutData : { id: checkoutData?.tabby_id },
    ...userInformation,
  };

  let checkoutButtonDisabled = true;
  if (isZiinaApplePaySelected) {
    checkoutButtonDisabled = false;
  } else if (isZiinaApplePaySelected2) {
    checkoutButtonDisabled = false;
  } else if (isStripePaySelected) {
    checkoutButtonDisabled = false;
  } else if (isMaxCommerceSelected) {
    checkoutButtonDisabled = false;
  }

  const isShipmentAddress =
    userId && userToken ? (getSelectShipmentAddressId ? false : true) : guestShippment?.email ? false : true;

  // Tap card sdk checkout and checkout button action
  const proceedeToCheckout = async () => {
    if (!isShippingAddress?.name) {
      return setAddressModal(true);
    } else if (isShipmentAddress) {
      return setAddressModal(true);
    }

    if (checkoutButtonDisabled) return alert("Please select a payment method.");

    const ItemsDataNitro = cartData?.map((item) => ({
      product_id: item?.product_id,
      price: Number(item?.prices?.value),
    }));
    if (countryCode === "IN") {
      if (window.nitro && typeof window.nitro.checkout === "function") {
        window.nitro.checkout({
          items: ItemsDataNitro,
        });
      } else {
        console.log("Nitro script not loaded");
      }
    }

    if (isRazerPaySelected) {
      createcheckout(checkoutPayload);
    }
    if (isRazerPaySelected2) {
      createcheckout(checkoutPayload);
    }
    if (isZiinaApplePaySelected) {
      createcheckout(checkoutPayload);
    }
    if (isZiinaApplePaySelected2) {
      createcheckout(checkoutPayload);
    }

    if (isMaxCommerceSelected) {
      createcheckout(checkoutPayload);
    }
    if (isMaxCommerceSelected2) {
      createcheckout(checkoutPayload);
    }
    if (isStripePaySelected) {
      createcheckout(checkoutPayload);
    }
  };

  function checkoutWithZiinaApple(data) {
    refetch();
    setCheckoutData(data);
    setZiinaApplePaySelected(data.selected);
    setZiinaApplePaySelected2(false);
    setRazerPaySelected2(false);
    setRazerPaySelected(false);
    setMaxCommerceSelected(false);
    setMaxCommerceSelected2(false);
    setStripePaySelected(false);
  }

  function checkoutWithZiinaApple2(data) {
    refetch();
    setCheckoutData(data);
    setZiinaApplePaySelected2(data.selected);
    setZiinaApplePaySelected(false);
    setRazerPaySelected2(false);
    setRazerPaySelected(false);
    setMaxCommerceSelected(false);
    setMaxCommerceSelected2(false);
    setStripePaySelected(false);
  }

  function checkoutWithStripePay(data) {
    refetch();
    setCheckoutData(data);
    setStripePaySelected(data.selected);
    setZiinaApplePaySelected(false);
    setRazerPaySelected2(false);
    setRazerPaySelected(false);
    setMaxCommerceSelected(false);
    setMaxCommerceSelected2(false);
    setZiinaApplePaySelected2(false);
  }

  function checkoutWithMaxCommerce(data) {
    refetch();
    setCheckoutData(data);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
    setRazerPaySelected2(false);
    setRazerPaySelected(false);
    setMaxCommerceSelected(data.selected);
    setMaxCommerceSelected2(false);
    setStripePaySelected(false);
  }

  function checkoutWithMaxCommerce2(data) {
    refetch();
    setCheckoutData(data);
    setZiinaApplePaySelected2(false);
    setZiinaApplePaySelected(false);
    setRazerPaySelected2(false);
    setRazerPaySelected(false);
    setMaxCommerceSelected(false);
    setMaxCommerceSelected2(data.selected);
  }

  const [isPaymentSwitchModal, setPaymentSwitchModal] = useState(false);
  useEffect(() => {
    if (isAction === "retry" && localCurrency?.includes(currency)) {
      setPaymentSwitchModal(true);
    }
  }, [currency]);
  function closePaymentSwitchModal() {
    setPaymentSwitchModal(false);
  }

  function tryAgainAction() {
    history.push("/purchase");
    setPaymentSwitchModal(false);
  }
  function okayAction() {
    setPaymentSwitchModal(false);
  }

  useEffect(() => {
    if (!isStripePaySelected && elseCurrency?.includes(currency)) {
      setCheckoutData({ selected: true, payment_by: "stripe_payment" });
      setStripePaySelected(true);
    }
  }, [isStripePaySelected, isAction, isPaymentSwitchModal, currency]);

  useEffect(() => {
    if (isAction !== "retry") {
      if (!isMaxCommerceSelected && localCurrency?.includes(currency)) {
        setCheckoutData({ selected: true, payment_by: "max_payment" });
        setMaxCommerceSelected(true);
      }
    }
  }, [isMaxCommerceSelected, isAction, isPaymentSwitchModal, currency]);

  useEffect(() => {
    if (isAction === "retry") {
      if (!isStripePaySelected && localCurrency?.includes(currency)) {
        setCheckoutData({ selected: true, payment_by: "stripe_payment" });
        setStripePaySelected(true);
      }
    }
  }, [isStripePaySelected, isAction, isPaymentSwitchModal, currency]);

  function processingLoading(loading, loading2) {
    if (loading) {
      return true;
    } else if (loading2) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <div className="Purchase-page">
      <div className="container purchase-container">
        <div className="row purchase-section" style={{ position: "relative" }}>
          {orderId && orderToken && <ConfirmCheckout tapId={tapId} orderId={orderId} orderToken={orderToken} />}

          <Modal
            className="country-modal payment-switch-modal"
            show={isPaymentSwitchModal}
            onHide={closePaymentSwitchModal}
            centered
            animation={false}
            backdrop="static"
            aria-labelledby="payment-switch-title"
          >
            <Modal.Body className="payment-switch-body">
              <div className="payment-switch-icon" aria-hidden="true">
                <PaymentOutlinedIcon />
              </div>

              <h5 id="payment-switch-title" className="payment-switch-title">
                Having trouble paying?
              </h5>
              <p className="payment-switch-text">
                If your payment didn&apos;t go through, you can try again with an alternate payment gateway.
              </p>

              <div className="payment-switch-actions">
                <Button variant="outlined" color="neutral" size="md" onClick={() => okayAction()}>
                  Okay
                </Button>
                <Button
                  className="try-action"
                  variant="solid"
                  color="warning"
                  size="md"
                  component={Link}
                  to="/purchase"
                  onClick={() => tryAgainAction()}
                >
                  Try again
                </Button>
              </div>
            </Modal.Body>
          </Modal>

          {!orderId && !orderToken && (
            <>
              {processingLoading(getTestLoading, checkoutResult?.isLoading) && (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    left: 0,
                    top: 0,
                    zIndex: 999,
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                    background: "#ffffffab",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div style={{ marginBottom: "10px", color: "#151517", display: "flex", alignItems: "center" }}>
                      Processing please wait!
                    </div>
                    <CircularProgress style={{ width: "2rem", height: "2rem", color: "#151517" }} />
                  </div>
                </div>
              )}

              <div className="col-md-6 p0">
                <div className="row">
                  {!userId && !userToken && (
                    <GuestShippingAddress isAddressModal={isAddressModal} setAddressModal={setAddressModal} />
                  )}
                  {userId && userToken && (
                    <ShippingAddress
                      isAddressModal={isAddressModal}
                      ShippingInfo={ShippingInfo}
                      getSelectShipmentAddressId={getSelectShipmentAddressId}
                      setSelectShipmentAddressId={setSelectShipmentAddressId}
                      setAddressModal={setAddressModal}
                    />
                  )}
                  {cartData?.length > 0 && (
                    <div className="col-md-12 pp-padding">
                      <div className="cp-cinfo-card">
                        <div
                          style={{
                            marginBottom: "15px",
                            gap: "5px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                          }}
                        >
                          <span className="alert alert-info alert-text">{t("select_payment_method")}</span>

                          {/* <span style={{ fontSize: "12px" }}>
                              {isAction === "retry" ? (
                                <div>
                                  Powered by{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="35"
                                    height="15"
                                    fill="#031323"
                                    viewBox="0 0 60 25"
                                    aria-label="Stripe logo"
                                  >
                                    <path
                                      fill="var(--hds-color-text-solid)"
                                      fill-rule="evenodd"
                                      d="M59.6444 14.2813h-8.062c.1843 1.9296 1.5983 2.5476 3.2032 2.5476 1.6352 0 2.9534-.3656 4.0453-.9506v3.3179c-1.1186.7115-2.5964 1.1068-4.5645 1.1068-4.011 0-6.8218-2.5122-6.8218-7.4783 0-4.19441 2.3837-7.52509 6.3017-7.52509 3.912 0 5.9537 3.28038 5.9537 7.49819 0 .3982-.0372 1.261-.0556 1.4835Zm-5.9241-5.62407c-1.0294 0-2.1739.72812-2.1739 2.58387h4.2573c0-1.85362-1.0721-2.58387-2.0834-2.58387ZM40.9547 20.303c-1.4411 0-2.322-.6087-2.9133-1.0417l-.0088 4.6271-4.1181.8755-.0014-19.19053h3.7543l.0864 1.01784c.6035-.52914 1.6114-1.29157 3.2256-1.29162 2.8925 0 5.6162 2.6052 5.6162 7.39971 0 5.2327-2.6948 7.6037-5.6409 7.6037Zm-.959-11.35573c-.9453 0-1.5376.34559-1.9669.81586l.0245 6.11967c.3997.433.9763.7813 1.9424.7813 1.5231 0 2.5437-1.6575 2.5437-3.8745 0-2.1544-1.037-3.84233-2.5437-3.84233Zm-11.7602-3.3739h4.1341V20.0088h-4.1341V5.57337Zm0-4.694699L32.3696 0v3.35821l-4.1341.87868V.878671ZM23.9198 10.2223v9.7861h-4.1156V5.57296h3.6867l.1317 1.21751c1.0035-1.7722 3.0722-1.41321 3.6209-1.21594v3.78524c-.5242-.16908-2.2894-.42779-3.3237.86253Zm-8.5525 4.7221c0 2.4275 2.5988 1.6719 3.1263 1.4609v3.3522c-.5492.3013-1.5437.5458-2.8901.5458-2.4441 0-4.2773-1.7999-4.2773-4.2379l.0173-13.17658 4.0206-.85464.0032 3.5395h3.1278V9.0857h-3.1278v5.8588-.0001Zm-4.9069.7026c0 2.9645-2.31051 4.6562-5.73464 4.6562-1.41958 0-2.92289-.2761-4.453935-.9347v-3.9319c1.382085.7516 3.093705 1.315 4.457755 1.315.91864 0 1.53106-.2459 1.53106-1.0069C6.26064 13.7786 0 14.5192 0 9.95995 0 7.04457 2.27622 5.2998 5.61655 5.2998c1.36404 0 2.72806.20934 4.09208.75351V9.9317c-1.25265-.67618-2.84332-1.05979-4.09588-1.05979-.86296 0-1.44753.24965-1.44753.8924.0001 1.85329 6.29518.97249 6.29518 5.88279v-.0001Z"
                                      clip-rule="evenodd"
                                    ></path>
                                  </svg>
                                </div>
                              ) : (
                                <div>
                                  Powered by{" "}
                                  <svg
                                    fill="none"
                                    height="15"
                                    viewBox="0 0 122 30"
                                    width="60"
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="text-label-primary h-6 w-24 lg:h-10 "
                                  >
                                    <path
                                      d="M14.8134 2.56066L8.66964 0.0027613L6.14326 6.22311L12.287 8.78101L14.8134 2.56066Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M23.5042 6.22354L20.9553 12.4539L27.0438 15.0012L29.6578 8.8043L23.5042 6.22354Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M6.14326 6.22311L0 8.78113L2.52638 15.0015L8.67009 12.4436L6.14326 6.22311Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M20.988 0L14.8344 2.58076L17.3834 8.81113L23.537 6.23037L20.988 0Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M27.0438 15.0012L20.9575 17.5591L23.4839 23.7795L29.6276 21.2216L27.0438 15.0012Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M14.8142 27.3839L20.958 30L23.4843 23.7796L17.3406 21.2217L14.8142 27.3839Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M6.14371 23.7795L8.67009 17.5591L2.52638 15.0015L0 21.2216L6.14371 23.7795Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M12.3025 21.1633L6.14887 23.7441L8.69783 29.9744L14.8514 27.3937L12.3025 21.1633Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M67.5986 6.09375H64.1231V23.7656H67.5986V6.09375Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M76.3463 6.09375H72.8708V23.7656H76.3463V6.09375Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M46.63 20.6058L58.8523 9.25362V6.09375H43.0386L41.7063 9.25362H53.9286L41.7063 20.6058V23.7656H59.1999L60.5322 20.6058H46.63Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M95.9829 6.09375V18.6747L85.0929 6.09375H81.6173V23.7656H85.0929V11.1261L95.9829 23.7656H99.4584V6.09375H95.9829Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                    <path
                                      d="M109.711 6.09375L102.471 23.7656H106.062L107.916 19.1428H116.199L118.111 23.7656H121.702L114.461 6.09375H109.711ZM109.248 15.983L112.086 9.07807L114.925 15.983H109.248Z"
                                      fill="currentColor"
                                      fill-opacity="0.9"
                                    ></path>
                                  </svg>
                                </div>
                              )}
                            </span> */}
                        </div>

                        {localCurrency?.includes(currency) && isAction !== "retry" && (
                          <MaxCommerce
                            isMaxCommerceSelected={isMaxCommerceSelected}
                            checkoutWithMaxCommerce={checkoutWithMaxCommerce}
                          />
                        )}

                        {localCurrency?.includes(currency) && isAction === "retry" && (
                          <StripePay
                            isStripePaySelected={isStripePaySelected}
                            checkoutWithStripePay={checkoutWithStripePay}
                          />
                        )}

                        {elseCurrency?.includes(currency) && (
                          <StripePay
                            isStripePaySelected={isStripePaySelected}
                            checkoutWithStripePay={checkoutWithStripePay}
                          />
                        )}

                        {localCurrency?.includes(currency) && (
                          <div
                            className="cp-pm-button-card"
                            style={{
                              display: "block",
                              textAlign: "center",
                              width: "100%",
                              padding: "7px 10px 7px 20px",
                              marginTop: "20px",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "10px",
                              }}
                            >
                              <div style={{ fontSize: "12px", color: "#000", textAlign: "left" }}>
                                Having issues with making payments? Try using an alternate payment gateway.
                              </div>
                              <Button
                                style={{ minHeight: "28px", maxHeight: "28px", fontWeight: 500 }}
                                variant="outlined"
                                size="sm"
                                component={Link}
                                to={isAction === "default" ? `/purchase?action=retry` : `/purchase`}
                              >
                                <div>Switch</div>
                              </Button>
                            </span>
                          </div>
                        )}

                        <Modal
                          className="pay-purchase-dialogue"
                          show={getPayByIframe}
                          onHide={closePayByIframe}
                          centered
                          animation={false}
                        >
                          <Modal.Body>
                            <IconButton
                              style={{ cursor: "pointer", position: "absolute", right: "5px", top: "5px", zIndex: 111 }}
                              onClick={closePayByIframe}
                            >
                              <CloseIcon className="Header-close-modal-icon" />
                            </IconButton>
                            {checkoutResult?.isLoading && (
                              <div
                                style={{
                                  height: "450px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <CircularProgress style={{ width: "2rem", height: "2rem", color: "#151517" }} />
                              </div>
                            )}

                            {getIframeMessage && (
                              <div
                                className="alert alert-danger"
                                style={{ background: "#fff0", border: "none", margin: 0, padding: "20px" }}
                              >
                                {getIframeMessage}
                              </div>
                            )}
                            {checkoutResult?.isSuccess && (
                              <div style={{ height: "500px" }} id="container-checkout-test"></div>
                            )}
                          </Modal.Body>
                        </Modal>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-5 pp-padding">
                <div className="row">
                  <div className="col-md-12 pp-padding">
                    <div className="cp-cinfo-card " style={{ marginBottom: "10px" }}>
                      <CartItems
                        isLoading={isLoading}
                        isFetching={isFetching}
                        cartData={cartData}
                        userData={userData}
                        checkoutResult={checkoutResult}
                      />

                      <CartIInformation
                        isLoading={isLoading}
                        isFetching={isFetching}
                        cartData={cartData}
                        userData={userData}
                        proceedeToCheckout={proceedeToCheckout}
                        couponData={couponData}
                        checkoutResult={checkoutResult}
                      />
                    </div>
                  </div>
                  <FooterText />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <br />
      <br />
    </div>
  );
}

export default CheckoutPage;
